import { createApp } from 'vue';
import App from './App.vue';
import Antd from 'ant-design-vue';
import "ant-design-vue/dist/reset.css";
import axios from "axios";
import VueAxios from "vue-axios";
import router from './router';
import '@/assets/styles/index.css'; // global css
import { BASE_URL, TIMEOUT } from './config/api';

const app = createApp(App);

// 配置axios默认值
axios.defaults.baseURL = BASE_URL;
axios.defaults.timeout = TIMEOUT;

// Axios Plugin
app.use(VueAxios, axios);
app.provide('BASE_URL', BASE_URL);
app.provide("axios", app.config.globalProperties.axios);
app.use(router);
app.use(Antd);

// 全局样式修复：处理弹窗层级问题
const fixZIndexIssues = () => {
  // 创建样式元素
  const style = document.createElement('style');
  style.textContent = `
    /* 修复Ant Design Vue组件层级问题 */
    .ant-select-dropdown { z-index: 9999 !important; }
    .ant-dropdown { z-index: 9999 !important; }
    .ant-tooltip { z-index: 9999 !important; }
    .ant-popover { z-index: 9999 !important; }
    .ant-modal-wrap { z-index: 9990 !important; }
    .ant-modal-mask { z-index: 9990 !important; }
    .ant-message { z-index: 10000 !important; }
    
    /* 会议编辑页面样式增强 */
    .meeting-edit .mt-record-header::before {
      transition: transform 0.3s ease;
    }
    
    .meeting-edit .mt-record-content .record-item.is-playing .mt-record-header::before {
      transform: scale(1.3);
      background-color: #1677ff;
      box-shadow: 0 0 0 4px rgba(24, 144, 255, 0.2);
    }
    
    .meeting-edit .mt-record-content .record-item:hover .mt-record-header::before {
      transform: scale(1.2);
    }
    
    /* 提升编辑功能区域的可见性 */
    .meeting-edit .mt-record-content .record-item.is-playing .editing-content {
      border-color: var(--primary-color);
    }

    /* 分段选择器组样式增强 */
    .ant-segmented {
      transition: all 0.3s ease;
    }
    
    .ant-segmented:hover {
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }
  `;
  // 添加到文档头部
  document.head.appendChild(style);
};

app.mount('#app');
fixZIndexIssues();

